import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';

const RightTwo = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.string,
            show: PropTypes.bool,
        };
        static defaultProps = {
            content: {},
        };
        /**
         * 插入html
         */
        createChannelInfo = () => {
            return { __html: this.props.content };
        };

        render() {
            return (
                <div style={{ display: this.props.show ? 'block' : 'none' }}>
                    <div dangerouslySetInnerHTML={this.createChannelInfo()} />
                </div>
            );
        }
    },
);

export { RightTwo };
export default RightTwo;
